import _ from 'lodash';
import { Record } from 'immutable';

import { NotFoundError } from '../lib/APIClient';
import { resolve } from '../helpers/LinkMapper';
import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';

import CustomerOrdersList from '../records/customer/CustomerOrdersList';
import Order from '../records/Order';
import StoredRefundCalculations from '../records/refund/StoredRefundCalculations';

const OrderHistoryService = {

    async search (user, { limit, page, refundable } = {}) {
        const userId = user.id;
        const params = _.pickBy({ limit, page, refundable }, _.negate(_.isUndefined));
        const response = await AuthenticatedAPIClient.get(`/customers/${ userId }/orders`, params);

        const { pagination, result } = response;
        const data = {
            pagination: pagination,
            orders: result
        };
        return resolve(data).as(CustomerOrdersList);
    },

    async fetch (orderId) {
        const response = await AuthenticatedAPIClient.get(`/orders/${ orderId }`);
        return resolve(response.result).as(Order);
    },

    async fetchRefundCalculations (orderId) {
        const response = await AuthenticatedAPIClient.get(`/orders/${ orderId }/refund/calculations`);
        return resolve(response).as(StoredRefundCalculations);
    },

    async getOrderHistory (orderId) {
        try {
            const response = await AuthenticatedAPIClient.get(`/orders/${ orderId }/filter-refunded-tickets`);
            return resolve(response.result).as(Order);
        } catch (error) {
            if (!(error instanceof NotFoundError)) {
                throw error;
            }
            return new Record();
        }
    }

};


export default OrderHistoryService;



// WEBPACK FOOTER //
// ./src/services/OrderHistoryService.js